import { CreditCardIssuers } from '@/getCardIssuer/getCardIssuer';
const getFormattedCardNumber = ([$number, $issuer]) => {
    var _a;
    if ($issuer === CreditCardIssuers.AMERICANEXPRESS) {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const [_, ...amexNumbers] = ($number !== null && $number !== void 0 ? $number : '')
            .padEnd(15, '#')
            .match(/([\d|#]{1,4})([\d|#]{1,6})([\d|#]{1,5})/) || [];
        return amexNumbers.join(' ');
    }
    return (_a = ($number !== null && $number !== void 0 ? $number : '')
        .padEnd(16, '#')
        .match(/([\d|#]{1,4})/g)) === null || _a === void 0 ? void 0 : _a.join(' ');
};
export default getFormattedCardNumber;
